import * as React from "react";

import {Errand, ErrandFilters} from 'features/errands/interfaces';
import {AdressFields, BuildingType, CaseStatus, CasetType} from 'features/errands/enums';

import { Tags, TagDesign } from '@atoms/Tags/Tags';

const validErrandTypesArray = [
    CasetType.WARRANTY,
    CasetType.MANAGEMENT,
    CasetType.MANAGEMENT_OTHER,
    CasetType.SERVICES,
    CasetType.ROUNDS_CASE,
    CasetType.COMPLAINT,
    CasetType.INSPECTION_REMARK,
    CasetType.CUSTOMER_SERVICE,
    CasetType.CUSTOMER_SERVICE_NO,
    CasetType.WARRANTY_FI,
    CasetType.ONE_YEAR_INSPECTION,
    CasetType.TWO_YEAR_INSPECTION,
    CasetType.CUSTOMER_SERVICE_FI,
];

export const filterErrands = (errands: Errand[], filters: ErrandFilters) => {
    return errands.filter(errand => {
        let status = true;
        let type = true;
        let date = true;
        let space = true;
        let search = true;
        let validErrandTypes = true;
        let buildingType = false;


        if(errand.hasOwnProperty('caseTypeName')) {
            validErrandTypes = validErrandTypesArray.includes(errand.caseTypeName as CasetType);
        }

        if(filters.status.length > 0) {
            status = filters.status.includes(errand.caseStatusId);
        }

        if(filters.type.length > 0) {
            type = filters.type.includes(errand.caseTypeName);
        }

        if(filters.dateStart && filters.dateEnd) {
            // removes time from date
            const errandDate = new Date(new Date(errand.creationDate).toDateString());

            date = errandDate >= filters.dateStart && errandDate <= filters.dateEnd;
        }

        if(filters.dateStart && !filters.dateEnd) {
            const errandDate = new Date(new Date(errand.creationDate).toDateString());
            date = errandDate >= filters.dateStart;
        }

        if(!filters.dateStart && filters.dateEnd) {
            const errandDate = new Date(new Date(errand.creationDate).toDateString());
            date = errandDate <= filters.dateEnd;
        }

        // TODO: More filters
        if(filters.buildingType.length > 0) {
            if(filters.buildingType.includes(BuildingType.OBJECT)) {
               if(errand.objectName) {
                   buildingType = true;
               }
            }

            if(filters.buildingType.includes(BuildingType.STAIRS)) {
                if(errand.buildingPartName && !errand.objectName) {
                    buildingType = true;
                }
            }

            if(filters.buildingType.includes(BuildingType.PROPERTY)) {
                if(!errand.buildingPartName && !errand.objectName) {
                    buildingType = true;
                }
            }
        } else {
            buildingType = true;
        }

        if(filters.space.length > 0) {
            space = filters.space.includes(errand.roomType);
        }

        const buildingName = getErrandAddress(errand);

        if(filters.searchString && filters.searchString.length > 0) {
            const searchLower = filters.searchString.toLowerCase();

            search = (!!buildingName && buildingName.toLowerCase().includes(searchLower))
                || (errand.hasOwnProperty('ticketNumber') && errand.ticketNumber.toLowerCase().includes(searchLower))
                || (errand.hasOwnProperty('objectName') && errand.objectName.toLowerCase().includes(searchLower));

            /*
            search = (errand.hasOwnProperty('objectAddress') && errand.objectAddress.toLowerCase().includes(filters.searchString.toLowerCase()))
                || (errand.hasOwnProperty('objectName') && errand.objectName.toLowerCase().includes(filters.searchString.toLowerCase()))
                || (errand.hasOwnProperty('ticketNumber') && errand.ticketNumber.toLowerCase().includes(filters.searchString.toLowerCase()))
                || (errand.hasOwnProperty('brfName') && errand.brfName.toLowerCase().includes(filters.searchString.toLowerCase()))
                || (errand.hasOwnProperty('buildingPartName') && errand.buildingPartName.toLowerCase().includes(filters.searchString.toLowerCase()));

             */
        }


        return status && type && date && space && search && validErrandTypes && buildingType;
    });
};

export type CaseStatusGroup =
    | CaseStatus.REGISTERED
    | CaseStatus.ONGOING
    | CaseStatus.EXECUTED
    | CaseStatus.COMPLETED;

/** De fyra huvudstatusarna webben visar (Registrerad/Pågående/Utförd/Avslutad); okända CRM-statusar ger undefined. */
export const getCaseStatusGroup = (value: CaseStatus | string): CaseStatusGroup | undefined => {
    switch (value as CaseStatus) {
        case CaseStatus.REGISTERED:
        case CaseStatus.REGISTERED_NO:
        case CaseStatus.REGISTERED_FI:
            return CaseStatus.REGISTERED;
        case CaseStatus.ONGOING:
        case CaseStatus.ONGOING_NO:
        case CaseStatus.ONGOING_FI:
        case CaseStatus.NOT_RESPONDING:
        case CaseStatus.NOT_RESPONDING_FI:
        case CaseStatus.WAITING_ON_CUSTOMER:
        case CaseStatus.WAITING_ON_CUSTOMER_FI:
        case CaseStatus.WAITING_ON_DECISION:
        case CaseStatus.WAITING_ON_DECISION_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_NO_PORTAL:
        case CaseStatus.WAITING_ON_WEATHER:
        case CaseStatus.WAITING_ON_WEATHER_FI:
        case CaseStatus.WAITING_ON_MATERIAL:
        case CaseStatus.WAITING_ON_MATERIAL_FI:
        case CaseStatus.WAITING_ON_INVESTIGATION:
        case CaseStatus.WAITING_ON_INVESTIGATION_FI:
        case CaseStatus.CUSTOMER_BOOKED:
        case CaseStatus.BOOKED:
        case CaseStatus.BOOKED_FI:
        case CaseStatus.CUSTOMER_NOT_BOOKED:
        case CaseStatus.MATERIALS:
        case CaseStatus.SUBCONTRACTOR:
        case CaseStatus.INVESTIGATION:
        case CaseStatus.INFO_FROM_CUSTOMER:
        case CaseStatus.OTHER_SEASON:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN_NO:
        case CaseStatus.EXECUTED_NO:
        case CaseStatus.REFERENCE:
        case CaseStatus.REFERENCE_NO:
            return CaseStatus.ONGOING;
        case CaseStatus.EXECUTED:
        case CaseStatus.EXECUTED_FI:
            return CaseStatus.EXECUTED;
        case CaseStatus.COMPLETED:
        case CaseStatus.COMPLETED_NO:
        case CaseStatus.COMPLETED_FI:
        case CaseStatus.CANCELLED_BY_CUSTOMER:
        case CaseStatus.CANCELLED_BY_CUSTOMER_NO:
        case CaseStatus.CANCELLED_BY_CUSTOMER_FI:
        case CaseStatus.SHREDDED:
        case CaseStatus.SHREDDED_NO:
        case CaseStatus.SHREDDED_FI:
            return CaseStatus.COMPLETED;
        default:
            return undefined;
    }
};

export const renderCaseStatusDot = (value: CaseStatus | string) => (
    <Tags
        tagDesign={TagDesign.DOT}
        status={getCaseStatusGroup(value)}
        className='status'
    />
);

export const isSubStatus = (status: CaseStatus | string) => {

    if(!status) return false;

    switch (status as CaseStatus) {
        case CaseStatus.REGISTERED:
        case CaseStatus.REGISTERED_NO:
        case CaseStatus.REGISTERED_FI:
        case CaseStatus.ONGOING:
        case CaseStatus.ONGOING_NO:
        case CaseStatus.ONGOING_FI:
        case CaseStatus.EXECUTED:
        case CaseStatus.EXECUTED_NO:
        case CaseStatus.EXECUTED_FI:
        case CaseStatus.COMPLETED:
        case CaseStatus.COMPLETED_NO:
        case CaseStatus.COMPLETED_FI:
            return false;
        case CaseStatus.NOT_RESPONDING:
        case CaseStatus.NOT_RESPONDING_FI:
        case CaseStatus.WAITING_ON_CUSTOMER:
        case CaseStatus.WAITING_ON_CUSTOMER_FI:
        case CaseStatus.WAITING_ON_DECISION:
        case CaseStatus.WAITING_ON_DECISION_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_NO_PORTAL:
        case CaseStatus.WAITING_ON_WEATHER:
        case CaseStatus.WAITING_ON_WEATHER_FI:
        case CaseStatus.WAITING_ON_MATERIAL:
        case CaseStatus.WAITING_ON_MATERIAL_FI:
        case CaseStatus.WAITING_ON_INVESTIGATION:
        case CaseStatus.WAITING_ON_INVESTIGATION_FI:
        case CaseStatus.CANCELLED_BY_CUSTOMER:
        case CaseStatus.CANCELLED_BY_CUSTOMER_NO:
        case CaseStatus.CANCELLED_BY_CUSTOMER_FI:
        case CaseStatus.CUSTOMER_BOOKED:
        case CaseStatus.BOOKED:
        case CaseStatus.BOOKED_FI:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN_NO:
        case CaseStatus.CUSTOMER_NOT_BOOKED:
        case CaseStatus.MATERIALS:
        case CaseStatus.SUBCONTRACTOR:
        case CaseStatus.INVESTIGATION:
        case CaseStatus.INFO_FROM_CUSTOMER:
        case CaseStatus.OTHER_SEASON:
        case CaseStatus.SHREDDED:
        case CaseStatus.SHREDDED_NO:
        case CaseStatus.SHREDDED_FI:
            return true;
        default:
            return false;
    }
};

export const sortErrandStatus = (a: Errand, b: Errand) => {
    return a.caseStatusId === b.caseStatusId ?
        0 :
        errandStatusOrder(a.caseStatusId as CaseStatus) > errandStatusOrder(b.caseStatusId as CaseStatus) ?
            1 :
            -1;
};

export const sortErrandDate = (a: Errand, b: Errand) => {
    return new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime();
};

export const errandStatusOrder = (guid: CaseStatus) => {
    switch (guid) {
        case CaseStatus.REFERENCE:
        case CaseStatus.REFERENCE_NO:
        case CaseStatus.COMPLETED:
        case CaseStatus.COMPLETED_NO:
        case CaseStatus.COMPLETED_FI:
        case CaseStatus.SHREDDED:
        case CaseStatus.SHREDDED_NO:
        case CaseStatus.SHREDDED_FI:
        case CaseStatus.CANCELLED_BY_CUSTOMER:
        case CaseStatus.CANCELLED_BY_CUSTOMER_NO:
        case CaseStatus.CANCELLED_BY_CUSTOMER_FI:
            return 400;
        case CaseStatus.EXECUTED:
        case CaseStatus.EXECUTED_FI:
            return 300;
        case CaseStatus.ONGOING:
        case CaseStatus.ONGOING_NO:
        case CaseStatus.ONGOING_FI:
        case CaseStatus.EXECUTED_NO:
        case CaseStatus.NOT_RESPONDING:
        case CaseStatus.NOT_RESPONDING_FI:
        case CaseStatus.WAITING_ON_CUSTOMER:
        case CaseStatus.WAITING_ON_CUSTOMER_FI:
        case CaseStatus.WAITING_ON_DECISION:
        case CaseStatus.WAITING_ON_DECISION_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_FI:
        case CaseStatus.WAITING_ON_SUBCONTRACTOR_NO_PORTAL:
        case CaseStatus.WAITING_ON_WEATHER:
        case CaseStatus.WAITING_ON_WEATHER_FI:
        case CaseStatus.WAITING_ON_MATERIAL:
        case CaseStatus.WAITING_ON_MATERIAL_FI:
        case CaseStatus.WAITING_ON_INVESTIGATION:
        case CaseStatus.WAITING_ON_INVESTIGATION_FI:
        case CaseStatus.CUSTOMER_BOOKED:
        case CaseStatus.CUSTOMER_NOT_BOOKED:
        case CaseStatus.MATERIALS:
        case CaseStatus.SUBCONTRACTOR:
        case CaseStatus.INVESTIGATION:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN:
        case CaseStatus.SUBCONTRACTOR_NO_LOGIN_NO:
        case CaseStatus.INFO_FROM_CUSTOMER:
        case CaseStatus.BOOKED:
        case CaseStatus.BOOKED_FI:
        case CaseStatus.OTHER_SEASON:
            return 200;
        case CaseStatus.REGISTERED:
        case CaseStatus.REGISTERED_NO:
        case CaseStatus.REGISTERED_FI:
            return 150;
        default:
            return 100;
    }
};

interface FullCaseAdress {
    adress: string;
    zipcode: string;
    city: string;
    governmentId: string;
}

export const getFullAdressFromString = (adressString: string) : FullCaseAdress => {
    const adress = {} as FullCaseAdress;
    const adressSplit = adressString.split(',');

    adress.adress = adressSplit[AdressFields.ADRESS];
    adress.zipcode = adressSplit[AdressFields.ZIP_CODE];
    adress.city = adressSplit[AdressFields.CITY];
    adress.governmentId = adressSplit[AdressFields.GOVERNMENT_ID];

    return adress;
};

export const getErrandAddress = (errand: Errand) => {
    // && errand.propertyId === DUMMY_BUILDING
    if(errand.otherResidentInfo) {
        const adress = getFullAdressFromString(errand.otherResidentInfo);

        if(adress) {
            return adress.adress;
        } else {
            return '';
        }
    }

    if(errand.objectName) {
        return errand.objectAddress;
    }

    if(!errand.objectName && errand.buildingPartName) {
        return errand.buildingPartName;
    }

    if(!errand.objectName && !errand.buildingPartName) {
        return errand.brfName;
    }

    return '';
};

export const translateType = (type: string) => {
    if(type === 'Befaring - Anmerkning') {
        return 'Reklamasjon - ettårsbefaring';
    }

    return type;

};
